import { React, useState, useEffect } from "react";
import { Tooltip } from "@mui/material";
import { Toaster, toast } from "react-hot-toast";
import axios from "axios";
import AsyncSelect from "react-select/async";
import Select from "react-select";
import dayjs from "dayjs";
import { useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";
import { createFacilityReservations } from "actions/action";
import { updateFacilityReservations } from "actions/action";
import { getFacilityReservation } from "actions/action";
import { isSameDay, isWithinInterval, parseISO } from "date-fns";
import DatePicker from "react-datepicker";
import { getBookedSlots } from "actions/action";
import SubmittingModal from "components/Modal";

export default function CreateFacilityReservation() {
  const location = useLocation();
  const { type, id, fid } = location.state;
  const [loading, setLoading] = useState(false);
  // let Updatedata;
  const [updateFlag, setUpdateFlag] = useState(false);
  const [userData, setUserData] = useState([]);
  const [facilityData, setFacilityData] = useState([]);
  const [clubData, setClubData] = useState([]);
  const [defaultFacility, setDefaultFacility] = useState({
    facility_id: "",
    facility_name: "",
  });
  const navigate = useNavigate();
  const [members, setMembers] = useState([
    { id: 1, name: "", contact: "", email: "" },
  ]);

  //  const formatDate = (date) => {
  //     return date ? dayjs(date).format("YYYY-MM-DD HH:mm:ss") : null;
  //   };

  const [bookedSlots, setBookedSLots] = useState([
    {
      start_date_time: "2025-05-27T15:07:00.000Z",
      end_date_time: "2025-05-29T16:07:00.000Z",
    },
    {
      start_date_time: "2025-05-30T10:00:00.000Z",
      end_date_time: "2025-05-30T11:00:00.000Z",
    },
  ]);

  const parsedSlots = bookedSlots
    .map(({ start_date_time: start, end_date_time: end }) => {
      if (typeof start !== "string" || typeof end !== "string") {
        console.error("Invalid date format:", { start, end });
        return null;
      }
      return {
        start: parseISO(start),
        end: parseISO(end),
      };
    })
    .filter(Boolean);

  const isBlockedDate = (date) =>
    parsedSlots.some(
      ({ start, end }) =>
        !isSameDay(date, start) &&
        !isSameDay(date, end) &&
        isWithinInterval(date, { start, end })
    );
  const isBlockedTime = (date) =>
    parsedSlots.some(({ start, end }) =>
      isWithinInterval(date, { start, end })
    );

  const statusOptions = [
    { value: "pending", label: "Pending" },
    { value: "approved", label: "Approved" },
    { value: "rejected", label: "Rejected" },
    { value: "cancelled", label: "Cancelled" },
    { value: "attended", label: "Attended" },
  ];

  // if (window.location.href.includes('/create-facility-reservation?id=')) {
  //   let getExtractUrl = window.location.href.split('/create-facility-reservation?id=')[1];
  //   if (getExtractUrl) {
  //     let splitUrl = getExtractUrl.split('/type==="view"=');
  //     getUserId = splitUrl[0] || "";
  //     type==="view" = splitUrl[1] === "true";
  //   }
  // }

  const [formData, setFormData] = useState({
    facility_id: "",
    facility_name: "",
    facility_registration_id: "",
    user_id: "",
    user_name: "",
    purpose: "",
    status: "",
    // project_title: '',
    // mentors_name: '',
    start_date_time: "",
    end_date_time: "",
    description: "",
    club_id: "",
    club_name: "",
    alternate_contact_details: [],
  });

  let [error, setError] = useState({
    facility_id: "",
    facility_registration_id: "",
    user_id: "",
    purpose: "",
    status: "",
    // project_title: '',
    // mentors_name: '',
    start_date_time: "",
    end_date_time: "",
    description: "",
    club_id: "",
    club_name: "",
    alternate_contact_details: [],
  });

  const fetchBookedSlots = async () => {
    try {
      const res = await getBookedSlots(fid);
      if (res.data && res.data.timings) {
        const array = res.data.timings;
        console.log("Booked Slots:", array);
        setBookedSLots(array);
      } else {
        toast.error(`Something went wrong.`);
      }
    } catch (err) {
      toast.error(`Something went wrong, ${err}`);
    }
  };

  useEffect(() => {
    if (type !== "create") getfacilityDataById(id);
    fetchBookedSlots();
    getFacilityDropdown();
    getClubDropdown();
    getUserDropdown();
  }, []);

  function getFormValues(e) {
    setFormData({ ...formData, [e.target.name]: e.target.value });
    setError({ ...error, [e.target.name]: "" });
  }

  function validateForm() {
    let errors = {};
    let isValid = true;

    if (!formData.facility_id) {
      errors.facility_id = "Facility selection is required";
      isValid = false;
    }

    if (!formData.user_id) {
      errors.user_id = "User selection is required";
      isValid = false;
    }

    // if (!formData.project_title.trim()) {
    //   errors.project_title = "Project title is required";
    //   isValid = false;
    // }

    // if (!formData.mentors_name.trim()) {
    //   errors.mentors_name = "Mentor's name is required";
    //   isValid = false;
    // }

    if (!formData.start_date_time) {
      errors.start_date_time = "Start date & time is required";
      isValid = false;
    }

    if (!formData.purpose) {
      errors.purpose = "Purpose is required";
      isValid = false;
    }

    if (!formData.end_date_time) {
      errors.end_date_time = "End date & time is required";
      isValid = false;
    }

    if (!formData.description.trim()) {
      errors.description = "Description is required";
      isValid = false;
    }

    // if (!formData.club_id) {
    //   errors.club_id = "Club is required";
    //   isValid = false;
    // }
    // if (!formData.club_name) {
    //   errors.club_name = "Club name is required";
    //   isValid = false;
    // }

    // if (members.length === 0 || members.some(member => !member.name.trim() || !member.contact.trim() || !member.email.trim())) {
    //   errors.alternate_contact_details = "All team members must have name, contact, and email";
    //   isValid = false;
    // }
    setError(errors);
    return isValid;
  }

  // async function getfacilityDataById(id) {
  //   try {
  //     const response = await getFacilityReservation(id);

  //     if (response.status === 200) {
  //       Updatedata = response.data;
  //       const parsedMembers = Updatedata.alternate_contact_details
  //         ? JSON.parse(Updatedata.alternate_contact_details).members.map(
  //             (member, index) => ({
  //               id: index + 1,
  //               name: member.name,
  //               contact: member.contact,
  //               email: member.email,
  //             })
  //           )
  //         : [{ id: 1, name: "", contact: "", email: "" }];
  //       //console.log("hi",Updatedata);
  //       setFormData({
  //         ...formData,
  //         facility_registration_id: Updatedata
  //           ? Updatedata.facility_registration_id
  //           : "",
  //         facility_id: Updatedata.facility_id,
  //         facility_name: Updatedata.facility_name,
  //         user_id: Updatedata.user_id,
  //         user_name: Updatedata.first_name,
  //         club_name: Updatedata.club_name,
  //         club_id: Updatedata?.club_id,
  //         purpose: Updatedata.purpose,
  //         status: Updatedata.status,
  //         start_date_time: Updatedata.start_date_time,
  //         end_date_time: Updatedata.end_date_time,
  //         description: Updatedata.description,
  //       });
  //       //console.log("hi3");
  //       setMembers(parsedMembers);
  //       //console.log("hi",formData);
  //     }
  //   } catch (error) {
  //     toast.error(error.response?.data?.message || "Something went wrong");
  //   }
  // }

  async function getfacilityDataById(id) {
    try {
      console.log("Fetching data for ID:", id);
      const response = await getFacilityReservation(id);
      console.log("API Response:", response);
      if (response.status === 200) {
        const updateData = response.data;
        console.log("updateData:", updateData);

        // Handled alternate_contact_details as an object, not a JSON string
        const parsedMembers = updateData.alternate_contact_details?.members
          ? updateData.alternate_contact_details.members.map(
            (member, index) => ({
              id: index + 1,
              name: member.name || "",
              contact: member.contact || "",
              email: member.email || "",
            })
          )
          : [{ id: 1, name: "", contact: "", email: "" }];

        const newFormData = {
          facility_registration_id: updateData?.facility_registration_id || "",
          facility_id: updateData?.facility_id || "",
          facility_name: updateData?.facility_name || "",
          user_id: updateData?.user_id || "",
          user_name: updateData?.first_name || "", // Matches API's first_name
          club_name: updateData?.club_name || "",
          club_id: updateData?.club_id || "",
          purpose: updateData?.purpose || "",
          status: updateData?.status || "",
          start_date_time: updateData?.start_date_time
            ? new Date(updateData.start_date_time)
            : "",
          end_date_time: updateData?.end_date_time
            ? new Date(updateData.end_date_time)
            : "",
          description: updateData?.description || "",
        };

        console.log("Setting formData:", newFormData);
        console.log("Setting members:", parsedMembers);
        setFormData(newFormData);
        setMembers(parsedMembers);
      } else {
        console.log("Unexpected status code:", response.status);
        toast.error("Failed to fetch facility data");
      }
    } catch (error) {
      console.error("Error in getFacilityDataById:", error);
      toast.error(error.response?.data?.message || "Something went wrong");
    }
  }

  const handleAddMember = () => {
    // Check if any existing member has empty fields
    const isIncomplete = members.some(
      (member) =>
        !member.name.trim() || !member.contact.trim() || !member.email.trim()
    );
    if (isIncomplete) {
      toast.error(
        "Please fill all fields for the current member before adding a new one."
      );
      return;
    }
    setMembers([
      ...members,
      {
        id: members.length + 1,
        name: "",
        contact: "",
        email: "",
      },
    ]);
  };

  const handleRemoveMember = (id) => {
    if (members.length > 1) {
      setMembers(members.filter((member) => member.id !== id));
    } else {
      setMembers([{ id: 1, name: "", contact: "", email: "" }]);
      toast.error("At least one member is required");
    }
  };

  const handleMemberChange = (id, field, value) => {
    setMembers(
      members.map((member) =>
        member.id === id ? { ...member, [field]: value } : member
      )
    );
  };

  async function getFacilityDropdown() {
    try {
      const token = localStorage.getItem("token");
      const getApiResponse = await axios.get(
        "https://api.nvcti.in/facilities/getAllFacilities",
        {
          // const getApiResponse = await axios.get("https://api.nvcti.in/facilities/getAllFacilities", {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );
      setFacilityData(getApiResponse.data.data || []);
      console.log("Facility Data:", getApiResponse.data.data);
      if (getApiResponse.data.data) {
        getApiResponse.data.data.forEach((element) => {
          if (element.facility_id === fid) {
            setDefaultFacility({
              facility_id: fid,
              facility_name: element.facility_name,
            });
          }
        });
        console.log("Default Facility:", defaultFacility);
      }
    } catch (error) {
      toast.error("Error fetching inventory:", error);
      setFacilityData([]);
    }
  }

  const loadFacilityOptions = async (inputValue, callback) => {
    try {
      if (!facilityData.length) {
        await getFacilityDropdown();
      }
      const filteredOptions = facilityData
        .filter((item) =>
          item?.name?.toLowerCase().includes(inputValue.toLowerCase() || [])
        )
        .map((item) => ({
          value: item.facility_id,
          label: item.facility_name,
        }));

      callback(filteredOptions);
    } catch (error) {
      toast.error("Error loading inventory options:", error);
      callback([]);
    }
  };

  async function getClubDropdown() {
    try {
      const token = localStorage.getItem("token");
      const getApiResponse = await axios.get(
        "https://api.nvcti.in/clubs/getAllClubs",
        {
          // const getApiResponse = await axios.get("https://api.nvcti.in/facilities/getAllFacilities", {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );
      setClubData(getApiResponse.data.data || []);
      console.log("Club Data:", getApiResponse.data.data);
    } catch (error) {
      toast.error("Error fetching inventory:", error);
      setClubData([]);
    }
  }

  const loadClubOptions = async (inputValue, callback) => {
    try {
      if (!facilityData.length) {
        await getClubDropdown();
      }
      const filteredOptions = facilityData
        .filter((item) =>
          item?.name?.toLowerCase().includes(inputValue.toLowerCase() || [])
        )
        .map((item) => ({
          value: item.club_id,
          label: item.club_name,
        }));

      callback(filteredOptions);
    } catch (error) {
      toast.error("Error loading clubs:", error);
      callback([]);
    }
  };

  async function getUserDropdown() {
    try {
      const token = localStorage.getItem("token");
      const getApiResponse = await axios.get(
        "https://api.nvcti.in/user/getAllUsers",
        {
          // const getApiResponse = await axios.get("https://api.nvcti.in/user/getAllUsers", {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );
      if (getApiResponse.status == 200) {
        setUserData(getApiResponse.data.data);
        console.log("User Data:", getApiResponse.data.data);
      } else {
        setUserData([]);
      }
    } catch (error) {
      toast.error("Error fetching inventory:", error);
      setUserData([]);
    }
  }

  const loadUserOptions = async (inputValue, callback) => {
    try {
      if (!userData.length) {
        await getUserDropdown();
      }
      const filteredOptions = userData
        .filter((user) =>
          user.first_name.toLowerCase().includes(inputValue.toLowerCase())
        )
        .map((user) => ({
          value: user.user_id,
          label: user.first_name,
        }));

      callback(filteredOptions);
    } catch (error) {
      toast.error("Error loading user options:", error);
      callback([]);
    }
  };

  async function onSubmitFormData(e) {
    e.preventDefault();
    if (!validateForm()) return;
    const teamMembersData = {
      members: members.map((member) => ({
        name: member.name,
        contact: member.contact,
        email: member.email,
      })),
    };
    const submissionData = {
      facility_registration_id: formData.facility_registration_id,
      user_id: Number(formData.user_id),
      facility_id: Number(formData.facility_id),
      club_id: Number(formData.club_id),
      club_name: formData.club_name,
      purpose: formData.purpose,
      status: formData.status,
      // project_title: formData.project_title,
      description: formData.description,
      // mentors_name: formData.mentors_name,
      alternate_contact_details: teamMembersData,
      start_date_time: new Date(formData.start_date_time).toISOString(),
      end_date_time: new Date(formData.end_date_time).toISOString(),
    };

    try {
      setLoading(true);
      if (type === "create") {
        const res = await createFacilityReservations(submissionData);
        if (res.status === 201 || res.status === 200) {
          toast.success("Facility Reserved Successfully!");
        } else {
          toast.error("Something went wrong.", res.err);
        }
      } else {
        const res = await updateFacilityReservations(submissionData, id);
        if (res.status === 201 || res.status === 200) {
          toast.success("Facility Reservation Updated Successfully!");
        } else {
          toast.error("Something went wrong.", res.err);
        }
      }

      navigate("/admin/facility-reservation");
    } catch (error) {
      toast.error("Something went wrong!");
    } finally {
      setLoading(false);
    }
  }

  function clearFormData() {
    setUpdateFlag(false);
    setFormData({
      facility_id: "",
      user_id: "",
      user_name: "",
      purpose: "",
      club_id: "",
      club_name: "",
      status: "",
      // project_title: '',  mentors_name: '',
      start_date_time: "",
      end_date_time: "",
      description: "",
      alternate_contact_details: [],
    });
    setError({
      facility_id: "",
      user_id: "",
      purpose: "",
      club_id: "",
      user_name: "",
      club_name: "",
      status: "",
      // project_title: '',  mentors_name: '',
      start_date_time: "",
      end_date_time: "",
      description: "",
      alternate_contact_details: [],
    });
  }
  console.log("formData", formData);
  return (
    <>
      <Toaster position="bottom-left" reverseOrder={false} />
      <SubmittingModal loading={loading} />
      <div className="flex justify-center items-center">
        <div className="relative flex flex-col min-w-0 break-words w-full mb-6 mt-6 shadow-lg rounded-lg bg-blueGray-100 border-0">
          <div className="rounded-t bg-white mb-0 px-6 py-6">
            <div className="text-center flex justify-between">
              <h6 className="text-blueGray-700 text-xl font-semibold">
                Facility Reservation
              </h6>
            </div>
          </div>
          <div className="flex-auto px-4 lg:px-10 py-10 pt-0">
            <form onSubmit={onSubmitFormData}>
              <h6 className="text-blueGray-400 text-xl mt-3 mb-6 font-semibold ">
                {" "}
                {type === "create"
                  ? "Facility Reservation"
                  : type === "view"
                    ? "View Facility Reservation"
                    : "Update Facility Reservation"}
              </h6>
              <div className="flex flex-wrap">
                {/* <div className="w-full lg:w-6/12 px-4">
                  <div className="relative w-full mb-3">
                    <label className="block text-blueGray-600 text-xs font-bold mb-2" htmlFor="grid-password">
                      Select Facility
                    </label>
                    <input
                      className="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                      value={formData.facility_name}
                      type="text"
                      name="facility_name"
                      disabled
                      placeholder='Facility Name'
                      //onChange={getFormValues}
                    />
                    {/* <AsyncSelect
                      isDisabled={type==="view"}
                      cacheOptions
                      loadOptions={loadFacilityOptions}
                      defaultOptions={facilityData.map((item) => ({
                        value: item.facility_id,
                        label: item.facility_name,
                      }))}
                      value={
                        facilityData.find((item) => item.facility_id === formData.facility_id)
                          ? {
                            value: formData.facility_id,
                            label: facilityData.find((item) => item.facility_id === formData.facility_id).facility_name,
                          }
                          :null
                      }
                      onChange={(selectedOption) => {
                        setFormData({ ...formData, facility_id: selectedOption?.value || '' });
                        setError({ ...error, facility_id: '' });
                      }}
                      classNamePrefix="react-select"
                      placeholder="Search Facility"
                      noOptionsMessage={() => 'No Data Found'}
                      styles={{
                        control: (provided, state) => ({
                          ...provided,
                          border: '1px solid #D1D5DB',
                          padding: '0px',
                          height: '42px',
                          minHeight: '42px',
                          borderRadius: '0.375rem',
                          boxShadow: state.isFocused ? '0 0 0 2px #3B82F6' : 'none',
                          backgroundColor: state.isDisabled ? '#F3F4F6' : 'white',
                          pointerEvents: state.isDisabled ? 'none' : 'auto',
                        }),
                        placeholder: (provided) => ({
                          ...provided,
                          color: '#9CA3AF',
                          fontSize: '0.875rem',
                          paddingLeft: '8px',
                        }),
                        valueContainer: (provided) => ({
                          ...provided,
                          padding: '6px 12px',
                        }),
                        indicatorsContainer: (provided) => ({
                          ...provided,
                          height: '42px',
                        }),
                        input: (provided) => ({
                          ...provided,
                          margin: '0',
                          padding: '0',
                          border: 'none',
                          boxShadow: 'none',
                          '& input': {
                            border: 'none !important',
                            boxShadow: 'none !important',
                          },
                        }),
                        option: (provided, state) => ({
                          ...provided,
                          backgroundColor: state.isSelected ? '#3B82F6' : state.isFocused ? '#F3F4F6' : 'white',
                          color: state.isSelected ? 'white' : '#111827',
                          cursor: 'pointer',
                          '&:active': {
                            backgroundColor: '#3B82F6',
                          },
                        }),
                      }}
                    /> 
                    {error.facility_id && <p className="text-red-500 text-xs mt-1">{error.facility_id}</p>}
                  </div>
                </div> */}
                {/* // Facility Selection */}
                <div className="w-full lg:w-6/12 px-4">
                  <div className="relative w-full mb-3">
                    <label
                      className="block text-blueGray-600 text-xs font-bold mb-2"
                      htmlFor="grid-password"
                    >
                      Select Facility
                    </label>
                    <AsyncSelect
                      isDisabled={type === "view"}
                      cacheOptions
                      loadOptions={loadFacilityOptions}
                      defaultOptions={facilityData.map((item) => ({
                        value: item.facility_id,
                        label: item.facility_name,
                      }))}
                      value={
                        formData.facility_id
                          ? {
                            value: formData.facility_id,
                            label:
                              facilityData.find(
                                (item) =>
                                  item.facility_id === formData.facility_id
                              )?.facility_name || "",
                          }
                          : null
                      }
                      onChange={(selectedOption) => {
                        setFormData({
                          ...formData,
                          facility_id: selectedOption?.value || "",
                          facility_name: selectedOption?.label || "",
                        });
                        setError({ ...error, facility_id: "" });
                      }}
                      classNamePrefix="react-select"
                      placeholder="Search Facility"
                      noOptionsMessage={() => "No Data Found"}
                      styles={{
                        control: (provided, state) => ({
                          ...provided,
                          border: "1px solid #D1D5DB",
                          padding: "0px",
                          height: "42px",
                          minHeight: "42px",
                          borderRadius: "0.375rem",
                          boxShadow: state.isFocused
                            ? "0 0 0 2px #3B82F6"
                            : "none",
                          backgroundColor: state.isDisabled
                            ? "#F3F4F6"
                            : "white",
                          pointerEvents: state.isDisabled ? "none" : "auto",
                        }),
                        placeholder: (provided) => ({
                          ...provided,
                          color: "#9CA3AF",
                          fontSize: "0.875rem",
                          paddingLeft: "8px",
                        }),
                        valueContainer: (provided) => ({
                          ...provided,
                          padding: "6px 12px",
                        }),
                        indicatorsContainer: (provided) => ({
                          ...provided,
                          height: "42px",
                        }),
                        input: (provided) => ({
                          ...provided,
                          margin: "0",
                          padding: "0",
                          border: "none",
                          boxShadow: "none",
                          "& input": {
                            border: "none !important",
                            boxShadow: "none !important",
                          },
                        }),
                        option: (provided, state) => ({
                          ...provided,
                          backgroundColor: state.isSelected
                            ? "#3B82F6"
                            : state.isFocused
                              ? "#F3F4F6"
                              : "white",
                          color: state.isSelected ? "white" : "#111827",
                          cursor: "pointer",
                          "&:active": {
                            backgroundColor: "#3B82F6",
                          },
                        }),
                      }}
                    />
                    {error.facility_id && (
                      <p className="text-red-500 text-xs mt-1">
                        {error.facility_id}
                      </p>
                    )}
                  </div>
                </div>
                {/* <div className="w-full lg:w-6/12 px-4">
                  <div className="relative w-full mb-3">
                    <label
                      className="block text-blueGray-600 text-xs font-bold mb-2"
                      htmlFor="grid-password"
                    >
                      Select Clubs
                    </label>
                    <input
                      className="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                      value={formData.club_name}
                      type="text"
                      name="club_name"
                      disabled
                      placeholder="Club Name"
                      //onChange={getFormValues}
                    />
                    {/* <AsyncSelect
                      isDisabled={type==="view"}
                      cacheOptions
                      loadOptions={loadClubOptions}
                      defaultOptions={clubData.map((item) => ({
                        value: item.club_id,
                        label: item.club_name,
                      }))}
                      value={
                        userData.find((item) => item.user_id === formData.user_id)
                          ? {
                            value: userData.find((item) => item.user_id === formData.user_id).club_id,
                            label: clubData.find((item)=>item.club_id === (userData.find((item) => item.user_id === formData.user_id).club_id ||'' ) )?.club_name,
                          }
                          : null
                      }
                      onChange={(selectedOption) => {
                        setFormData({ ...formData, club_id: selectedOption?.value || '',club_name:selectedOption?.label||'' });
                        setError({ ...error, club_id: '' });
                      }}
                      classNamePrefix="react-select"
                      placeholder="Search Facility"
                      noOptionsMessage={() => 'No Data Found'}
                      styles={{
                        control: (provided, state) => ({
                          ...provided,
                          border: '1px solid #D1D5DB',
                          padding: '0px',
                          height: '42px',
                          minHeight: '42px',
                          borderRadius: '0.375rem',
                          boxShadow: state.isFocused ? '0 0 0 2px #3B82F6' : 'none',
                          backgroundColor: state.isDisabled ? '#F3F4F6' : 'white',
                          pointerEvents: state.isDisabled ? 'none' : 'auto',
                        }),
                        placeholder: (provided) => ({
                          ...provided,
                          color: '#9CA3AF',
                          fontSize: '0.875rem',
                          paddingLeft: '8px',
                        }),
                        valueContainer: (provided) => ({
                          ...provided,
                          padding: '6px 12px',
                        }),
                        indicatorsContainer: (provided) => ({
                          ...provided,
                          height: '42px',
                        }),
                        input: (provided) => ({
                          ...provided,
                          margin: '0',
                          padding: '0',
                          border: 'none',
                          boxShadow: 'none',
                          '& input': {
                            border: 'none !important',
                            boxShadow: 'none !important',
                          },
                        }),
                        option: (provided, state) => ({
                          ...provided,
                          backgroundColor: state.isSelected ? '#3B82F6' : state.isFocused ? '#F3F4F6' : 'white',
                          color: state.isSelected ? 'white' : '#111827',
                          cursor: 'pointer',
                          '&:active': {
                            backgroundColor: '#3B82F6',
                          },
                        }),
                      }}
                    /> */}
                {/* {error.club_id && (
                      <p className="text-red-500 text-xs mt-1">
                        {error.club_id}
                      </p>
                    )}
                  </div> */}
                {/* </div> */}
                {/* Select Clubs */}
                <div className="w-full lg:w-6/12 px-4">
                  <div className="relative w-full mb-3">
                    <label
                      className="block text-blueGray-600 text-xs font-bold mb-2"
                      htmlFor="grid-password"
                    >
                      Select Clubs
                    </label>
                    <AsyncSelect
                      isDisabled={type === "view"}
                      cacheOptions
                      loadOptions={loadClubOptions}
                      defaultOptions={clubData.map((item) => ({
                        value: item.club_id,
                        label: item.club_name,
                      }))}
                      value={
                        formData.club_id
                          ? {
                            value: formData.club_id,
                            label:
                              clubData.find(
                                (item) => item.club_id === formData.club_id
                              )?.club_name || "",
                          }
                          : null
                      }
                      onChange={(selectedOption) => {
                        setFormData({
                          ...formData,
                          club_id: selectedOption?.value || "",
                          club_name: selectedOption?.label || "",
                        });
                        setError({ ...error, club_id: "" });
                      }}
                      classNamePrefix="react-select"
                      placeholder="Search Club"
                      noOptionsMessage={() => "No Data Found"}
                      styles={{
                        control: (provided, state) => ({
                          ...provided,
                          border: "1px solid #D1D5DB",
                          padding: "0px",
                          height: "42px",
                          minHeight: "42px",
                          borderRadius: "0.375rem",
                          boxShadow: state.isFocused
                            ? "0 0 0 2px #3B82F6"
                            : "none",
                          backgroundColor: state.isDisabled
                            ? "#F3F4F6"
                            : "white",
                          pointerEvents: state.isDisabled ? "none" : "auto",
                        }),
                        placeholder: (provided) => ({
                          ...provided,
                          color: "#9CA3AF",
                          fontSize: "0.875rem",
                          paddingLeft: "8px",
                        }),
                        valueContainer: (provided) => ({
                          ...provided,
                          padding: "6px 12px",
                        }),
                        indicatorsContainer: (provided) => ({
                          ...provided,
                          height: "42px",
                        }),
                        input: (provided) => ({
                          ...provided,
                          margin: "0",
                          padding: "0",
                          border: "none",
                          boxShadow: "none",
                          "& input": {
                            border: "none !important",
                            boxShadow: "none !important",
                          },
                        }),
                        option: (provided, state) => ({
                          ...provided,
                          backgroundColor: state.isSelected
                            ? "#3B82F6"
                            : state.isFocused
                              ? "#F3F4F6"
                              : "white",
                          color: state.isSelected ? "white" : "#111827",
                          cursor: "pointer",
                          "&:active": {
                            backgroundColor: "#3B82F6",
                          },
                        }),
                      }}
                    />
                    {error.club_id && (
                      <p className="text-red-500 text-xs mt-1">
                        {error.club_id}
                      </p>
                    )}
                  </div>
                </div>
                {/* <div className="w-full lg:w-6/12 px-4">
                  <div className="relative w-full mb-3">
                    <label
                      className="block  text-blueGray-600 text-xs font-bold mb-2"
                      htmlFor="grid-password"
                    >
                      Select User
                    </label>
                    <input
                      className="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                      value={formData.user_name}
                      type="text"
                      name="user_name"
                      disabled
                      placeholder="User Name"
                      //onChange={getFormValues}
                    />
                    {/* <AsyncSelect
                      isDisabled={type==="view"}
                      cacheOptions
                      loadOptions={loadUserOptions}
                      defaultOptions={userData.map((user) => ({
                        value: user.user_id,
                        label: user.first_name,
                      }))}
                      value={
                        userData.find((user) => user.user_id == formData.user_id)
                          ? {
                            value: formData.user_id,
                            label: userData.find((user) => user.user_id == formData.user_id).first_name,
                          }
                          : null
                      }
                      onChange={(selectedOption) => {
                        setFormData({ ...formData, user_id: selectedOption.value , 
                          club_id: userData.find((item) => item.user_id === selectedOption.value).club_id || '',
                          club_name:clubData.find((item)=>item.club_id === (userData.find((item) => item.user_id === selectedOption.value).club_id ||'3' ) )?.club_name
                        });
                        setError({ ...error, user_id: '',club_id: '',club_name:'' });

          
                      }}
                      classNamePrefix="react-select"
                      placeholder="Search User"
                      noOptionsMessage={() => 'No Data Found'}
                      styles={{
                        control: (provided, state) => ({
                          ...provided,
                          border: '1px solid #D1D5DB',
                          padding: '0px',
                          height: '42px',
                          minHeight: '42px',
                          borderRadius: '0.375rem',
                          boxShadow: state.isFocused ? '0 0 0 2px #3B82F6' : 'none',
                          backgroundColor: state.isDisabled ? '#F3F4F6' : 'white',
                          pointerEvents: state.isDisabled ? 'none' : 'auto',
                        }),
                        placeholder: (provided) => ({
                          ...provided,
                          color: '#9CA3AF',
                          fontSize: '0.875rem',
                          paddingLeft: '8px',
                        }),
                        valueContainer: (provided) => ({
                          ...provided,
                          padding: '6px 12px',
                        }),
                        indicatorsContainer: (provided) => ({
                          ...provided,
                          height: '42px',
                        }),
                        input: (provided) => ({
                          ...provided,
                          margin: '0',
                          padding: '0',
                          border: 'none',
                          boxShadow: 'none',
                          '& input': {
                            border: 'none !important',
                            boxShadow: 'none !important',
                          },
                        }),
                        option: (provided, state) => ({
                          ...provided,
                          backgroundColor: state.isSelected ? '#3B82F6' : state.isFocused ? '#F3F4F6' : 'white',
                          color: state.isSelected ? 'white' : '#111827',
                          cursor: 'pointer',
                          '&:active': {
                            backgroundColor: '#3B82F6',
                          },
                        }),
                      }}
                    /> */}
                {/* {error.user_id && (
                      <p className="text-red-500 text-xs mt-1">
                        {error.user_id}
                      </p>
                    )}
                  </div> */}
                {/* </div> */}
                {/* // User Selection */}
                <div className="w-full lg:w-6/12 px-4">
                  <div className="relative w-full mb-3">
                    <label
                      className="block text-blueGray-600 text-xs font-bold mb-2"
                      htmlFor="grid-password"
                    >
                      Select User
                    </label>
                    {/* over here i have commented club id and club name cause all users dont have club id and name yet */}
                    <AsyncSelect
                      isDisabled={type === "view"}
                      cacheOptions
                      loadOptions={loadUserOptions}
                      defaultOptions={userData.map((user) => ({
                        value: user.user_id,
                        label: user.first_name,
                      }))}
                      value={
                        formData.user_id
                          ? {
                            value: formData.user_id,
                            label:
                              userData.find(
                                (user) => user.user_id === formData.user_id
                              )?.first_name || "",
                          }
                          : null
                      }
                      onChange={(selectedOption) => {
                        const selectedUser = userData.find(
                          (user) => user.user_id === selectedOption?.value
                        );
                        setFormData({
                          ...formData,
                          user_id: selectedOption?.value || "",
                          user_name: selectedOption?.label || "",
                          // club_id: selectedUser?.club_id || "",
                          // club_name:
                          //   clubData.find(
                          //     (item) => item.club_id === selectedUser?.club_id
                          //   )?.club_name || "",
                        });
                        setError({
                          ...error,
                          user_id: "",
                          // club_id: "",
                          // club_name: "",
                        });
                      }}
                      classNamePrefix="react-select"
                      placeholder="Search User"
                      noOptionsMessage={() => "No Data Found"}
                      styles={{
                        control: (provided, state) => ({
                          ...provided,
                          border: "1px solid #D1D5DB",
                          padding: "0px",
                          height: "42px",
                          minHeight: "42px",
                          borderRadius: "0.375rem",
                          boxShadow: state.isFocused
                            ? "0 0 0 2px #3B82F6"
                            : "none",
                          backgroundColor: state.isDisabled
                            ? "#F3F4F6"
                            : "white",
                          pointerEvents: state.isDisabled ? "none" : "auto",
                        }),
                        placeholder: (provided) => ({
                          ...provided,
                          color: "#9CA3AF",
                          fontSize: "0.875rem",
                          paddingLeft: "8px",
                        }),
                        valueContainer: (provided) => ({
                          ...provided,
                          padding: "6px 12px",
                        }),
                        indicatorsContainer: (provided) => ({
                          ...provided,
                          height: "42px",
                        }),
                        input: (provided) => ({
                          ...provided,
                          margin: "0",
                          padding: "0",
                          border: "none",
                          boxShadow: "none",
                          "& input": {
                            border: "none !important",
                            boxShadow: "none !important",
                          },
                        }),
                        option: (provided, state) => ({
                          ...provided,
                          backgroundColor: state.isSelected
                            ? "#3B82F6"
                            : state.isFocused
                              ? "#F3F4F6"
                              : "white",
                          color: state.isSelected ? "white" : "#111827",
                          cursor: "pointer",
                          "&:active": {
                            backgroundColor: "#3B82F6",
                          },
                        }),
                      }}
                    />
                    {error.user_id && (
                      <p className="text-red-500 text-xs mt-1">
                        {error.user_id}
                      </p>
                    )}
                  </div>
                </div>
                {/* <div className="w-full lg:w-6/12 px-4">
                  <div className="relative w-full mb-3">
                    <label className="block text-blueGray-600 text-xs font-bold mb-2" htmlFor="grid-password">
                      Project Title
                    </label>
                    <input
                      placeholder='Project Title'
                      className="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                      readOnly={type==="view"} 
                      name="project_title"
                      type="text"
                      value={formData.project_title}
                      onChange={getFormValues}
                    />
                     {error.project_title && <p className="text-red-500 text-xs mt-1">{error.project_title}</p>}
                  </div>
                </div> */}
                {/* <div className="w-full lg:w-6/12 px-4">
                  <div className="relative w-full mb-3">
                    <label className="block text-blueGray-600 text-xs font-bold mb-2" htmlFor="grid-password">
                      Mentor Name
                    </label>
                    <input
                      placeholder='Mentor Name'
                      className="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                      name="mentors_name"
                      type="text"
                      value={formData.mentors_name}
                      readOnly={type==="view"} 
                      onChange={getFormValues}
                    />
                     {error.mentors_name && <p className="text-red-500 text-xs mt-1">{error.mentors_name}</p>}
                  </div>
                </div> */}
                <div className="w-full lg:w-6/12 px-4">
                  <div className="relative w-full mb-3">
                    <label className="block text-blueGray-600 text-xs font-bold mb-2">
                      Start Date & Time
                    </label>
                    <DatePicker
                      selected={
                        formData.start_date_time
                          ? new Date(formData.start_date_time)
                          : null
                      }
                      onChange={(date) =>
                        getFormValues({
                          target: {
                            name: "start_date_time",
                            value: date,
                          },
                        })
                      }
                      disabled={type === "view"}
                      showTimeSelect
                      dateFormat="yyyy-MM-dd HH:mm"
                      timeIntervals={30}
                      filterDate={(date) => !isBlockedDate(date)}
                      // filterTime={(time) => !isBlockedTime(time)}
                      filterTime={(time) => !isBlockedTime(new Date(time))}
                      //dateFormat="Pp"
                      className="w-full border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring ease-linear transition-all duration-150"
                      wrapperClassName="w-full"
                      //className="border border-gray-300 rounded px-4 py-2 shadow w-full"
                      placeholderText="yyyy-mm-dd hh:mm"
                    />
                    {/* <input
                      className="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                      value={formData.start_date_time}
                      type="time"
                      name="start_date_time"
                      readOnly={type==="view"} 
                      onChange={getFormValues}
                    /> */}

                    {error.start_date_time && (
                      <p className="text-red-500 text-xs mt-1">
                        {error.start_date_time}
                      </p>
                    )}
                  </div>
                </div>
                <div className="w-full lg:w-6/12 px-4">
                  <div className="relative w-full mb-3">
                    <label className="block text-blueGray-600 text-xs font-bold mb-2">
                      End Date & Time
                    </label>
                    <DatePicker
                      selected={
                        formData.end_date_time
                          ? new Date(formData.end_date_time)
                          : null
                      }
                      onChange={(date) =>
                        getFormValues({
                          target: {
                            name: "end_date_time",
                            value: date,
                          },
                        })
                      }
                      disabled={type === "view"}
                      showTimeSelect
                      dateFormat="yyyy-MM-dd HH:mm"
                      timeIntervals={30}
                      filterDate={(date) => !isBlockedDate(date)}
                      filterTime={(time) => !isBlockedTime(time)}
                      //dateFormat="Pp"
                      className="w-full border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring ease-linear transition-all duration-150"
                      wrapperClassName="w-full"
                      //className="border border-gray-300 rounded px-4 py-2 shadow w-full"
                      placeholderText="yyyy-mm-dd hh:mm"
                    />

                    {/* <input
                      className="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                      value={formData.end_date_time}
                      type="time"
                      name="end_date_time"
                      readOnly={type==="view"} 
                      onChange={getFormValues}
                    /> */}
                    {error.end_date_time && (
                      <p className="text-red-500 text-xs mt-1">
                        {error.end_date_time}
                      </p>
                    )}
                  </div>
                </div>
                <div className="w-full lg:w-6/12 px-4">
                  <div className="relative w-full mb-3">
                    <label className="block text-blueGray-600 text-xs font-bold mb-2">
                      Purpose
                    </label>
                    <input
                      className="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                      value={formData.purpose}
                      type="text"
                      name="purpose"
                      readOnly={type === "view"}
                      placeholder="Purpose"
                      onChange={getFormValues}
                    />
                    {error.purpose && (
                      <p className="text-red-500 text-xs mt-1">
                        {error.purpose}
                      </p>
                    )}
                  </div>
                </div>
                {/* <div className="w-full lg:w-6/12 px-4">
                  <div className="relative w-full mb-3">
                    <label
                      className="block  text-blueGray-600 text-xs font-bold mb-2"
                      htmlFor="grid-password"
                    >
                      Status
                    </label>
                    <Select
                      isDisabled={type === "view"}
                      options={statusOptions}
                      value={statusOptions.find(
                        (option) => option.value === formData.status
                      )}
                      onChange={(selectedOption) => {
                        setFormData({
                          ...formData,
                          status: selectedOption.value,
                        });
                        setError({ ...error, status: "" });
                      }}
                      classNamePrefix="react-select"
                      placeholder="Select Status"
                      noOptionsMessage={() => "No options"}
                      styles={{
                        control: (provided, state) => ({
                          ...provided,
                          border: "1px solid #D1D5DB",
                          padding: "0px",
                          height: "42px",
                          minHeight: "42px",
                          borderRadius: "0.375rem",
                          boxShadow: state.isFocused
                            ? "0 0 0 2px #3B82F6"
                            : "none",
                          backgroundColor: state.isDisabled
                            ? "#F3F4F6"
                            : "white",
                          pointerEvents: state.isDisabled ? "none" : "auto",
                        }),
                        placeholder: (provided) => ({
                          ...provided,
                          color: "#9CA3AF",
                          fontSize: "0.875rem",
                          paddingLeft: "8px",
                        }),
                        valueContainer: (provided) => ({
                          ...provided,
                          padding: "6px 12px",
                        }),
                        indicatorsContainer: (provided) => ({
                          ...provided,
                          height: "42px",
                        }),
                        option: (provided, state) => ({
                          ...provided,
                          backgroundColor: state.isSelected
                            ? "#3B82F6"
                            : state.isFocused
                            ? "#F3F4F6"
                            : "white",
                          color: state.isSelected ? "white" : "#111827",
                          cursor: "pointer",
                          "&:active": {
                            backgroundColor: "#3B82F6",
                          },
                        }),
                        input: () => ({
                          display: "none", // 👈 This removes the blinking cursor
                        }),
                      }}
                    />

                    {error.user_id && (
                      <p className="text-red-500 text-xs mt-1">
                        {error.user_id}
                      </p>
                    )}
                  </div>
                </div> */}
                <div className="w-full lg:w-6/12 px-4">
                  <div className="relative w-full mb-3">
                    <label
                      className="block text-blueGray-600 text-xs font-bold mb-2"
                      htmlFor="status-select"
                    >
                      Status
                    </label>
                    <Select
                      isDisabled={type === "view"}
                      options={statusOptions}
                      value={
                        statusOptions.find(
                          (option) => option.value === formData.status
                        ) || null
                      }
                      onChange={(selectedOption) => {
                        setFormData({
                          ...formData,
                          status: selectedOption?.value || "",
                        });
                        setError({ ...error, status: "" });
                      }}
                      classNamePrefix="react-select"
                      placeholder="Select Status"
                      noOptionsMessage={() => "No options"}
                      styles={{
                        control: (provided, state) => ({
                          ...provided,
                          border: "1px solid #D1D5DB",
                          padding: "0px",
                          height: "42px",
                          minHeight: "42px",
                          borderRadius: "0.375rem",
                          boxShadow: state.isFocused
                            ? "0 0 0 2px #3B82F6"
                            : "none",
                          backgroundColor: state.isDisabled
                            ? "#F3F4F6"
                            : "white",
                          pointerEvents: state.isDisabled ? "none" : "auto",
                        }),
                        placeholder: (provided) => ({
                          ...provided,
                          color: "#9CA3AF",
                          fontSize: "0.875rem",
                          paddingLeft: "8px",
                        }),
                        valueContainer: (provided) => ({
                          ...provided,
                          padding: "6px 12px",
                        }),
                        indicatorsContainer: (provided) => ({
                          ...provided,
                          height: "42px",
                        }),
                        option: (provided, state) => ({
                          ...provided,
                          backgroundColor: state.isSelected
                            ? "#3B82F6"
                            : state.isFocused
                              ? "#F3F4F6"
                              : "white",
                          color: state.isSelected ? "white" : "#111827",
                          cursor: "pointer",
                          "&:active": {
                            backgroundColor: "#3B82F6",
                          },
                        }),
                      }}
                    />
                    {error.status && (
                      <p
                        className="text-red-500 text-xs mt-1"
                        id="status-error"
                      >
                        {error.status}
                      </p>
                    )}
                  </div>
                </div>
                <div className="w-full lg:w-12/12 px-4">
                  <div className="relative w-full mb-3">
                    <label className="block  text-blueGray-600 text-xs font-bold mb-2">
                      Description
                    </label>
                    <textarea
                      className="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                      placeholder="Enter your description."
                      rows="4"
                      name="description"
                      value={formData.description}
                      onChange={getFormValues}
                      readOnly={type === "view"}
                    />
                    {error.description && (
                      <p className="text-red-500 text-xs mt-1">
                        {error.description}
                      </p>
                    )}
                  </div>
                </div>
              </div>
              <hr className="mt-6 border-b-1 border-blueGray-300" />
              <h6 className="text-blueGray-400 text-xl mt-3 mb-6 font-semibold ">
                Alternate Contact Details
              </h6>
              {members.map((member, index) => (
                <div key={member.id} className="w-full flex flex-wrap">
                  <div className="w-full lg:w-6/12 px-4">
                    <div className="relative w-full mb-3">
                      <label className="block text-blueGray-600 text-xs font-bold mb-2">
                        Name
                      </label>
                      <input
                        placeholder="Member Name"
                        className="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                        type="text"
                        value={member.name}
                        readOnly={type === "view"}
                        onChange={(e) =>
                          handleMemberChange(member.id, "name", e.target.value)
                        }
                      />
                    </div>
                  </div>
                  <div className="w-full lg:w-6/12 px-4">
                    <div className="relative w-full mb-3">
                      <label className="block text-blueGray-600 text-xs font-bold mb-2">
                        Contact No
                      </label>
                      <input
                        placeholder="Contact No"
                        className="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                        maxLength={10}
                        type="text"
                        value={member.contact}
                        readOnly={type === "view"}
                        onChange={(e) =>
                          handleMemberChange(
                            member.id,
                            "contact",
                            e.target.value
                          )
                        }
                      />
                    </div>
                  </div>
                  <div className="w-full lg:w-6/12 px-4">
                    <div className="relative w-full mb-3">
                      <label className="block text-blueGray-600 text-xs font-bold mb-2">
                        Email
                      </label>
                      <input
                        placeholder="Email"
                        className="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                        type="email"
                        value={member.email}
                        readOnly={type === "view"}
                        onChange={(e) =>
                          handleMemberChange(member.id, "email", e.target.value)
                        }
                      />
                    </div>
                    {error.alternate_contact_details && (
                      <p className="text-red-500 text-xs mt-1">
                        {error.alternate_contact_details}
                      </p>
                    )}
                  </div>
                  {!(type === "view") ? (
                    <>
                      <div className="w-full lg:w-6/12 px-4">
                        <div className="relative w-full mb-6 flex gap-4 mt-6">
                          <Tooltip title="Add new member">
                            <button
                              className="bg-lightBlue-500  text-white active:bg-lightBlue-600 font-semibold text-sm px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none mr-1 ease-linear transition-all duration-150"
                              type="button"
                              onClick={handleAddMember}
                            >
                              <i className="fas fa-plus mr-2"></i> Add
                            </button>
                          </Tooltip>
                          <Tooltip title="Remove this member">
                            <button
                              className="bg-red-500  text-white active:bg-lightBlue-600 font-semibold text-sm px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none mr-1 ease-linear transition-all duration-150"
                              type="button"
                              onClick={() => handleRemoveMember(member.id)}
                              disabled={members.length === 1}
                            >
                              <i className="fas fa-times mr-2"></i> Cancel
                            </button>
                          </Tooltip>
                        </div>
                      </div>
                    </>
                  ) : (
                    ""
                  )}
                </div>
              ))}
              <div className="flex justify-end w-full">
                <Tooltip title="Back" arrow>
                  <button
                    className="mt-10 text-white bg-blueGray-700 active:bg-blueGray-600 font-semibold text-sm px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none mr-auto ease-linear transition-all duration-150"
                    type="button"
                    onClick={(e) => {
                      e.preventDefault();
                      navigate("/admin/facility-reservation");
                      clearFormData();
                    }}
                  >
                    {"<< "}Back
                  </button>
                </Tooltip>
                {!(type === "view") ? (
                  <>
                    <Tooltip title="Submit" arrow>
                      <button
                        className="bg-lightBlue-500 mt-10 text-white active:bg-lightBlue-600 font-semibold text-sm px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none mr-1 ease-linear transition-all duration-150"
                        type="submit"
                      >
                        {type === "create" ? "Submit" : "Update"}
                      </button>
                    </Tooltip>
                    <Tooltip title="Clear" arrow>
                      <button
                        className="bg-red-500 mt-10 text-white active:bg-lightBlue-600 font-semibold text-sm px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none mr-1 ease-linear transition-all duration-150"
                        type="button"
                      >
                        Clear
                      </button>
                    </Tooltip>
                  </>
                ) : (
                  ""
                )}
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
}
